const actions = {
    BUNDLE_CREATE_REQUEST: 'BUNDLE_CREATE_REQUEST',
    BUNDLE_CREATE_SUCCESS: 'BUNDLE_CREATE_SUCCESS',
    BUNDLE_CREATE_ERROR: 'BUNDLE_CREATE_ERROR',

    BUNDLE_READ_REQUEST: 'BUNDLE_READ_REQUEST',
    BUNDLE_READ_SUCCESS: 'BUNDLE_READ_SUCCESS',
    BUNDLE_READ_ERROR: 'BUNDLE_READ_ERROR',

    BUNDLE_UPDATE_REQUEST: 'BUNDLE_UPDATE_REQUEST',
    BUNDLE_UPDATE_SUCCESS: 'BUNDLE_UPDATE_SUCCESS',
    BUNDLE_UPDATE_ERROR: 'BUNDLE_UPDATE_ERROR',

    BUNDLE_ARCHIVE_REQUEST: 'BUNDLE_ARCHIVE_REQUEST',
    BUNDLE_ARCHIVE_SUCCESS: 'BUNDLE_ARCHIVE_SUCCESS',
    BUNDLE_ARCHIVE_ERROR: 'BUNDLE_ARCHIVE_ERROR',

    BUNDLE_DELETE_REQUEST: 'BUNDLE_DELETE_REQUEST',
    BUNDLE_DELETE_SUCCESS: 'BUNDLE_DELETE_SUCCESS',
    BUNDLE_DELETE_ERROR: 'BUNDLE_DELETE_ERROR',

    BUNDLE_CHANGE: 'BUNDLE_CHANGE',
    BUNDLE_CHANGE_IS_SELLING: 'BUNDLE_CHANGE_IS_SELLING',
    BUNDLE_CHANGE_IS_BUYING: 'BUNDLE_CHANGE_IS_BUYING',
    BUNDLE_SET_TOTAL: 'BUNDLE_SET_TOTAL',
    BUNDLE_RESET_STATE: 'BUNDLE_RESET_STATE',

    BUNDLE_READ_ITEM_PRICE_REQUEST: 'BUNDLE_READ_ITEM_PRICE_REQUEST',
    BUNDLE_READ_ITEM_PRICE_SUCCESS: 'BUNDLE_READ_ITEM_PRICE_SUCCESS',
    BUNDLE_READ_ITEM_PRICE_ERROR: 'BUNDLE_READ_ITEM_PRICE_ERROR',

    BUNDLE_READ_ITEMS_PRICE_REQUEST: 'BUNDLE_READ_ITEMS_PRICE_REQUEST',
    BUNDLE_READ_ITEMS_PRICE_SUCCESS: 'BUNDLE_READ_ITEMS_PRICE_SUCCESS',
    BUNDLE_READ_ITEMS_PRICE_ERROR: 'BUNDLE_READ_ITEMS_PRICE_ERROR',

    createBundle: request => ({
        type: actions.BUNDLE_CREATE_REQUEST,
        request,
    }),
    readBundle: id => ({
        type: actions.BUNDLE_READ_REQUEST,
        id,
    }),
    updateBundle: (id, request) => ({
        type: actions.BUNDLE_UPDATE_REQUEST,
        id,
        request,
    }),
    archiveBundle: (id, request) => ({
        type: actions.BUNDLE_ARCHIVE_REQUEST,
        id,
        request,
    }),
    deleteBundle: id => ({
        type: actions.BUNDLE_DELETE_REQUEST,
        id,
    }),
    changeBundle: (request, reset = false) => ({
        type: actions.BUNDLE_CHANGE,
        request,
        reset,
    }),
    changeIsSelling: isSelling => ({
        type: actions.BUNDLE_CHANGE_IS_SELLING,
        isSelling,
    }),
    changeIsBuying: isBuying => ({
        type: actions.BUNDLE_CHANGE_IS_BUYING,
        isBuying,
    }),
    setTotal: total => ({
        type: actions.BUNDLE_SET_TOTAL,
        total,
    }),
    resetState: () => ({
        type: actions.BUNDLE_RESET_STATE,
    }),

    // read only one item's price in bundle
    readItemPrice: (productId, key, unitId) => ({
        type: actions.BUNDLE_READ_ITEM_PRICE_REQUEST,
        productId,
        key,
        unitId,
    }),
    // read all items' price in bundle
    readItemsPrice: () => ({
        type: actions.BUNDLE_READ_ITEMS_PRICE_REQUEST,
    }),
};

export default actions;
